export class Review {
    // default base values
    review_group_id?: number;
    response_id?: number;
    origin_id?: number;
    id?: number;

    description?: string;

    // inputs from screen
    review_percentage: number;
    order_count: number;

    // integration - check response
    reviewed: number;

    // integration - calce view
    factory_id: number;
    season_id: number;
    model_id: number;
    brand_id: number;
    line_id: number;
    logo: any;
    
    // yet integration, but grouped
    factory_name: string;
    season_name: string;
    model_name: string;
    brand_name: string;
    line_name: string;
    status: string;

    hidden: boolean;

    // datetime
    created_at: Date;
    updated_at: Date;

    // not required, the id is it
    // integration_id?: number;

    constructor(partial: Partial<Review>) {
        this.review_group_id = partial.review_group_id || 0;
        this.response_id = partial.response_id || 0;
        this.origin_id = partial.origin_id || 0;
        this.id = partial.id || 0;

        this.review_percentage = partial.review_percentage || 0;
        this.order_count = partial.order_count || 0;

        this.reviewed = partial.reviewed || 0;

        this.factory_id = partial.factory_id;
        this.season_id = partial.season_id;
        this.model_id = partial.model_id;
        this.brand_id = partial.brand_id;
        this.line_id = partial.line_id;
        this.status = partial.status;
        
        this.factory_name = partial.factory_name;
        this.season_name = partial.season_name;
        this.model_name = partial.model_name;
        this.brand_name = partial.brand_name;
        this.line_name = partial.line_name;

        this.hidden = partial.hidden;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/review.ts